"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function toggleInCallPip(isVisible = null) {
    return {
        type: constants_1.app.actions.toggleInCallPip,
        payload: isVisible
    };
}
exports.toggleInCallPip = toggleInCallPip;
function togglePipPreview(isVisible = null) {
    return {
        type: constants_1.app.actions.togglePipPreview,
        payload: isVisible
    };
}
exports.togglePipPreview = togglePipPreview;
function togglePresentationPrompt(isVisible = null) {
    return {
        type: constants_1.app.actions.togglePresentationPrompt,
        payload: isVisible
    };
}
exports.togglePresentationPrompt = togglePresentationPrompt;
function changeVolumeInCall(value = 0.5) {
    return {
        type: constants_1.app.actions.changeVolumeInCall,
        payload: value
    };
}
exports.changeVolumeInCall = changeVolumeInCall;
function setIsLegacyServiceDegraded(value = true) {
    return {
        type: constants_1.app.actions.setIsLegacyServiceDegraded,
        payload: value
    };
}
exports.setIsLegacyServiceDegraded = setIsLegacyServiceDegraded;
function setHdmiPresentationConnected(value = false) {
    return {
        type: constants_1.app.actions.setHdmiPresentationConnected,
        payload: value
    };
}
exports.setHdmiPresentationConnected = setHdmiPresentationConnected;
function setHdmiPresentationActive(value = false) {
    return {
        type: constants_1.app.actions.setHdmiPresentationActive,
        payload: value
    };
}
exports.setHdmiPresentationActive = setHdmiPresentationActive;
function setSharePresentationInfo(value = null) {
    return {
        type: constants_1.app.actions.setSharePresentationInfo,
        payload: value
    };
}
exports.setSharePresentationInfo = setSharePresentationInfo;
function setSharePinCode(value = null) {
    return {
        type: constants_1.app.actions.setSharePinCode,
        payload: value
    };
}
exports.setSharePinCode = setSharePinCode;
function setSharePresentationActive(value = false) {
    return {
        type: constants_1.app.actions.setSharePresentationActive,
        payload: value
    };
}
exports.setSharePresentationActive = setSharePresentationActive;
function setSipIncomingCall(value = null) {
    return {
        type: constants_1.app.actions.setSipIncomingCall,
        payload: value
    };
}
exports.setSipIncomingCall = setSipIncomingCall;
function setSipActiveCall(value = null) {
    return {
        type: constants_1.app.actions.setSipActiveCall,
        payload: value
    };
}
exports.setSipActiveCall = setSipActiveCall;
function selectCallLayout(layout = '') {
    return {
        type: constants_1.app.actions.selectCallLayout,
        payload: layout
    };
}
exports.selectCallLayout = selectCallLayout;
function showMeetingStartPrompt(value = null) {
    return {
        type: constants_1.app.actions.showMeetingStartPrompt,
        payload: value
    };
}
exports.showMeetingStartPrompt = showMeetingStartPrompt;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/actions/app.js
// module id = 505
// module chunks = 0